import { render } from "./GeneralTableView.vue?vue&type=template&id=656698ec&scoped=true&ts=true"
import script from "./GeneralTableView.vue?vue&type=script&lang=ts"
export * from "./GeneralTableView.vue?vue&type=script&lang=ts"

import "./GeneralTableView.vue?vue&type=style&index=0&id=656698ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656698ec"]])

export default __exports__